import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';

const apiOrigin = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
axios.defaults.baseURL = apiOrigin;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

